import React, { useMemo } from 'react';
import { ReactComponent as SvgArrow } from '../Assets/icons/ARROW-SHARP.svg';
import './ReaderStartCard.scss';
import {
    ProductInMiddle,
    ReaderEndCard,
    ReaderEndCardModal,
    ReaderEndCardWrapper,
    ReaderStartCardModal,
} from './ReaderEndCard';
import { Product } from '../../Models/Product';
import KodanshaSubmit from '../KodanshaUIKit/KodanshaSubmit/KodanshaSubmit';
import { LoginAtom, LoginStatus, LoginStatusAtom } from '../../store/AccountStore';
import KodanshaUnderlinedText from '../KodanshaUIKit/KodanshaUnderlinedText/KodanshaUnderlinedText';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { CheckoutOverlayVisible, LoginOverlayVisible } from '../../store/OverlayStore';
import { useHistory } from 'react-router-dom';
import {
    isTheChapterInCart,
    isTheChapterPurchased,
    isTheVolumeInCart,
    isTheVolumePurchased,
    readerReadableUrlOrDefault,
} from '../../utils/utils';
import { Cart } from '../../Models/Cart';
import { AddToCartAction, CartAtom, DeductFromCartAction } from '../../store/CartStore';
import dayjs from 'dayjs';
import { FetchMyBooksAtom } from '../../store/MyBooksStore';
import Logo from '../Assets/icons/haeder-white.png';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';


export enum ReaderStartCardType {
    AvailableForFreeWithAccount,
    AvailableForPurchaseWithAccount,
    AvailableForPurchase,
    NotFound
}

interface ReaderStartCardProps {
    cardType: ReaderStartCardType;
    currentProduct: Product|false;
    isOwnedByUser: boolean;

    onCloseReader: () => void;
}

export function ReaderStartCard(props: ReaderStartCardProps): JSX.Element{
    const SetLoginOverlay = useSetAtom(LoginOverlayVisible);
    const loginStatus = useAtomValue(LoginAtom);
    const setCheckoutOverlay = useSetAtom(CheckoutOverlayVisible);
    const removeFromCart = useSetAtom(DeductFromCartAction);
    const history = useHistory<{returnPath: string}>();
    const cart = useAtomValue<Cart | false>(CartAtom);
    const [myBooks, fetchBooks] = useAtom(FetchMyBooksAtom);
    const [, addToCart] = useAtom(AddToCartAction);
    const [isLoggedIn] = useAtom(LoginStatusAtom);

    const nextProductPriceType = useMemo(() => {
        if (!props.currentProduct) {
            return false;
        }
        return props.currentProduct.variants[0]?.priceType;
    }, [props.currentProduct]);

    const isNextProductOwned = useMemo(() => {
        if (!props.currentProduct) {
            return false;
        }
        return (props.currentProduct as Product).subCategory === 'Volume' ? isTheVolumePurchased(myBooks, props.currentProduct.id) : isTheChapterPurchased(myBooks, props.currentProduct, props.currentProduct.volumeNumber);
    }, [props.currentProduct, myBooks]);

    const isItemInTheCart = useMemo(() => {
        if (!props.currentProduct) {
            return false;
        }
        return isTheVolumeInCart(cart, props.currentProduct) || isTheChapterInCart(cart, props.currentProduct);
    }, [cart, props.currentProduct]);

    const onCartRemoveClicked = async () => {
        if(props.currentProduct ===false){return;}
        await removeFromCart({ productId: props.currentProduct.id, variantId: props.currentProduct.variants[0]?.id });
    };

    const onCartAddClicked = async () => {
        if(props.currentProduct ===false){return;}
        if (props.currentProduct.publishDate.isAfter(dayjs())) {
            return;
        }
        const priceType = nextProductPriceType;
        const hasBook = isNextProductOwned;

        if (priceType === 'Free') {
            //TODO: READER uses readable url
            // TODO: THIS IS A HOTFIX. We need to enforce a refresh so that the reader state resets properly
            //history.push('/reader/' + props.nextProduct.id);

            window.location.href = readerReadableUrlOrDefault(props.currentProduct);
            return;
        }

        if (priceType === 'FreeForRegistered' && loginStatus === "LoggedIn") {
            //TODO: READER uses readable url
            // TODO: THIS IS A HOTFIX. We need to enforce a refresh so that the reader state resets properly
            window.location.href = readerReadableUrlOrDefault(props.currentProduct);
            //history.push('/reader/' + props.nextProduct.id);
            return;
        }

        if (priceType === 'FreeForRegistered' && loginStatus !== "LoggedIn") {
            SetLoginOverlay(true);
            return;
        }

        if (hasBook) {
            // TODO: THIS IS A HOTFIX. We need to enforce a refresh so that the reader state resets properly
            //history.push('/reader/' + props.nextProduct.id);
            //TODO: READER uses readable url
            window.location.href = readerReadableUrlOrDefault(props.currentProduct);
            return;
        }

        await addToCart({ productId: props.currentProduct.id, variantId: props.currentProduct.variants[0]?.id });
        // setIsActive(true);
    };

    console.debug("SHOW STARTCARD", props.cardType);
    switch (props.cardType) {
        case ReaderStartCardType.AvailableForFreeWithAccount:
            return(<div className={"ReaderStartCard"}>
                <ReaderEndCardWrapper>
                    <ReaderStartCardModal title={'Login to read for free'} onCloseCallback={props.onCloseReader}>
                        <div className='next-is-owned-modal-middle-wrapper'>
                      <span className='next-is-owned-modal-text'>
                          Create an account or log in to an existing one to read this content for free!
                      </span>

                            <ProductInMiddle nextProduct={props.currentProduct} />

                            <KodanshaSubmit onSubmitClicked={() => SetLoginOverlay(true)}
                                            text={'log in or sign up'}
                                            styles={'submit-button'} />

                        </div>
                    </ReaderStartCardModal>
                </ReaderEndCardWrapper>
            </div>);
        case ReaderStartCardType.AvailableForPurchase:
        case ReaderStartCardType.AvailableForPurchaseWithAccount:
            return(<div className={"ReaderStartCard"}>
                <ReaderEndCardWrapper>
                    <ReaderStartCardModal
                        title={'Purchase Volume'}
                        onCloseCallback={() => {props.onCloseReader();}}
                        end={() => {
                            return loginStatus !== "LoggedIn" ? <div className='already-own-product-wrapper'>
                                <div className='already-own-product-text'>
                                    Already own this product?
                                </div>

                                <KodanshaUnderlinedText text={'Log In'} onClick={() => SetLoginOverlay(true)} />
                            </div> : null;
                        }}
                    >
                        <div className='next-is-owned-modal-middle-wrapper'>
                      <span className='next-is-owned-modal-text'>
                          You need to purchase this product to access it.
                      </span>

                            <ProductInMiddle nextProduct={props.currentProduct} />

                            {isItemInTheCart ?
                                <div className='remove-from-cart-wrapper'>
                                    <div className='remove-from-cart-inner-wrapper'>
                                        <span className='product-added-text'>Product added to cart</span>
                                        <span onClick={onCartRemoveClicked} className='product-remove-text'>Remove</span>
                                    </div>

                                    <div className='remove-from-cart-inner-wrapper'>
                                        <div onClick={() => {
                                            history.push('/');
                                            if(isLoggedIn === "LoggedIn"){
                                                setCheckoutOverlay(true);
                                            } else {
                                                SetLoginOverlay(true)
                                            }
                                        }} className='checkout-button-wrapper'>
                                <span className='checkout-button-text'>
                                    Checkout
                                </span>
                                            <SvgArrow fill={'white'} className={'checkout-button-icon'} />
                                        </div>
                                    </div>
                                </div>
                                :
                                <KodanshaSubmit text={'Add to cart'} styles={'submit-button'}
                                                onSubmitClicked={onCartAddClicked} />
                            }

                        </div>
                    </ReaderStartCardModal>
                </ReaderEndCardWrapper>
            </div>);

        case ReaderStartCardType.NotFound:
            return(<div className={"ReaderStartCard"}>
                <div className={'ReaderEndCard-catch-up-container'}>
                    <img src={Logo} className={'ReaderEndCard-logo'} />
                    <div className={'ReaderEndCard-catch-up'}>
                        <h3 className={'ReaderEndCard-catch-up-header'}>{'Product not found!'}</h3>

                        <KodanshaArrow text={'Close Reader'}
                                       onClick={() => {
                                           props.onCloseReader();
                                       }}
                                       styles={'ReaderEndCard-catch-up-button'}
                                       invert={true}
                                       withArrow={false} />

                    </div>
                </div>
            </div>);

    }

}
